import DOMPurify from 'dompurify';

// @see https://github.com/cure53/DOMPurify
// @see https://github.com/cure53/DOMPurify/blob/8fce59d9e8423afce06724115700e8376cc1b9eb/demos/README.md

export default function htmlSanitize(dirty: string): string {
  if (typeof dirty === 'string') {
    return DOMPurify.sanitize(dirty, {
      // 👇 We only support HTML - not SVG and MathML
      USE_PROFILES: { html: true },
      RETURN_DOM_FRAGMENT: false,
      RETURN_DOM: false,
    });
  }
  return '';
}
